<template>
  <div>
    <sales-light-list :sales="programReservations"></sales-light-list>
  </div>
</template>

<script>
import ProgramMixin from '../ProgramMixin'

export default {
  name: 'ProgramReservations',
  components: {
    SalesLightList: () => import('@/components/adv/SalesLightList')
  },
  mixins: [ProgramMixin],
  watch: {
    sourceProgramReservations (v) {
      this.updateSources({ reservations: v })
    }
  }
}
</script>
